import { DBConfig } from 'ngx-indexed-db';

export const dbConfig: DBConfig = {
  name: 'BWEB',
  version: 1,
  objectStoresMeta: [
    {
      store: 'ModuleStructure',
      storeConfig: { keyPath: 'moduleId', autoIncrement: false },
      storeSchema: [
        { name: 'structure', keypath: 'structure', options: { unique: false } },
      ],
    },
    {
      store: 'shoppingCart',
      storeConfig: { keyPath: 'name', autoIncrement: false },
      storeSchema: [
        {
          keypath: 'value',
          name: 'value',
          options: { unique: false },
        },
      ],
    },
  ],
};
